import axios from 'axios';
import { message } from 'antd';
import { getOnt } from './auth';
// axios.defaults.headers.post['Content-Type'] = 'application/json'
const service = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000, // request timeout
  headers: { 'Content-Type': 'application/json' },
});
// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const token = getOnt();
    if (token) {
      config.headers.common.Authorization = token;
    }

    config.data = JSON.stringify(config.data);
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    // if (response.headers.authorization) {
    //   setToken(response.headers.authorization)
    // }
    const res = response.data;
    return res;
  },
  (error) => {
    const rest = error.response;
    console.error(rest); // for debug
    if (rest) {
      if (rest.status === 400) {
        message.error(rest.data.desc);
      } else if (rest.status === 401) {
        message.error('Please login again!');
      }
    } else {
      message.error('Api Error, Please Try Again!');
    }
    return Promise.reject(error);
  },
);

export default service;
